export enum HoldingType {
  Other = 1,
  Office = 2,
  Industrial = 3,
  Residential = 4,
  SingleFamily = 5,
  MultiFamily = 6,
  Retail = 7,
  Condominium = 8,
  Development = 9,
  Hotel = 10,
  ManufacturedHomeCommunity = 11,
  RVPark = 12,
  SelfStorage = 13
}

// tslint:disable-next-line:no-namespace
export namespace HoldingType {
  export function toString(holdingType: HoldingType): string {
    switch (holdingType) {
      case HoldingType.Office:
        return 'Office';
      case HoldingType.Residential:
        return 'Residential';
      case HoldingType.Industrial:
        return 'Industrial';
      case HoldingType.SingleFamily:
        return 'Single-family';
      case HoldingType.MultiFamily:
        return 'Multi-family';
      case HoldingType.Retail:
        return 'Retail';
      case HoldingType.Other:
        return 'Other';
      case HoldingType.Condominium:
        return 'Condominium';
      case HoldingType.Development:
        return 'Development';
      case HoldingType.Hotel:
        return 'Hotel';
      case HoldingType.ManufacturedHomeCommunity:
        return 'Manufactured home community';
      case HoldingType.RVPark:
        return 'RV park';
      case HoldingType.SelfStorage:
        return 'Self-storage';
      default:
        return null;
    }
  }

  export function listAll() {
    return [HoldingType.Office, HoldingType.Industrial, HoldingType.Residential, HoldingType.SingleFamily, HoldingType.MultiFamily,
      HoldingType.Retail, HoldingType.Other, HoldingType.Condominium, HoldingType.Development, HoldingType.Hotel,
      HoldingType.ManufacturedHomeCommunity, HoldingType.RVPark, HoldingType.SelfStorage ];
  }

  export function parse(holdingTypeStr: string): HoldingType {
    return HoldingType[holdingTypeStr];
  }
}

export default HoldingType;
